import { createContext, useContext, useEffect, useState, useCallback } from "react";

const DICT = {
  tr: {
    street: "Streetwear",
    oldmoney: "Old Money",
    season: "SS26 — İki dünya, tek imza",
    heroStreet1: "Beton.",
    heroStreet2: "Floresan.",
    heroStreet3: "Sokak.",
    heroOld1: "Malikane,",
    heroOld2: "deniz",
    heroOld3: "ve at.",
    enterStreet: "Sokağa gir",
    enterOld: "Malikaneye gir",
    drag: "Fareyi kaydır",
    marquee: "Sokaktan malikaneye",
    manifestoKicker: "Manifesto",
    manifesto1: "İki dünya.",
    manifesto2: "Tek koltuk.",
    manifestoBody: "ANVOCRA, floresan ışığın altındaki eski bir koltukla malikanedeki deri chesterfield arasında duran bir markadır. Biri sokağın sesini, diğeri zamanın sessizliğini taşır. Biz ikisini aynı dikişle birleştiriyoruz.",
    worlds: "Dünyalar",
    streetTile: "Brutalist beton, gece stüdyoları, ağır gramaj.",
    oldTile: "Yat güverteleri, at ahırları, kütüphane sessizliği.",
    discover: "Keşfet",
    selection: "Seçki",
    allPieces: "Tüm parçalar",
    pieces: "parça",
    size: "Beden",
    addToBag: "Çantaya ekle",
    added: "Çantaya eklendi",
    pickSize: "Lütfen beden seçin",
    bag: "Çanta",
    details: "Detaylar",
    related: "Aynı dünyadan",
    crossTo: "Diğer dünyaya geç",
    notFound: "Parça bulunamadı",
    back: "Geri",
    collStreetLead: "Brutalist beton duvarlar, gece yarısı stüdyoları ve floresan tüplerin vızıltısı. Sokak için dikildi.",
    collOldLead: "Yat güverteleri, sabah binicilik turları ve malikane kütüphaneleri. Zamanın ötesinde, sessiz lüks.",
    footer: "Sokaktan malikaneye, tek imza.",
    loading: "Yükleniyor",
    rights: "Tüm hakları saklıdır",
  },
  en: {
    street: "Streetwear",
    oldmoney: "Old Money",
    season: "SS26 — Two worlds, one signature",
    heroStreet1: "Concrete.",
    heroStreet2: "Fluorescent.",
    heroStreet3: "Street.",
    heroOld1: "Estate,",
    heroOld2: "sea",
    heroOld3: "& horse.",
    enterStreet: "Enter the street",
    enterOld: "Enter the estate",
    drag: "Move your cursor",
    marquee: "From the street to the estate",
    manifestoKicker: "Manifesto",
    manifesto1: "Two worlds.",
    manifesto2: "One seat.",
    manifestoBody: "ANVOCRA lives between a worn sofa under fluorescent light and a leather chesterfield in a country estate. One carries the noise of the street, the other the silence of time. We bind them with the same stitch.",
    worlds: "Worlds",
    streetTile: "Brutalist concrete, night studios, heavyweight cloth.",
    oldTile: "Yacht decks, stable yards, library silence.",
    discover: "Discover",
    selection: "Selection",
    allPieces: "All pieces",
    pieces: "pieces",
    size: "Size",
    addToBag: "Add to bag",
    added: "Added to bag",
    pickSize: "Please choose a size",
    bag: "Bag",
    details: "Details",
    related: "From the same world",
    crossTo: "Cross to the other world",
    notFound: "Piece not found",
    back: "Back",
    collStreetLead: "Brutalist concrete walls, midnight studios and the hum of fluorescent tubes. Cut for the street.",
    collOldLead: "Yacht decks, morning rides and estate libraries. Beyond time, quietly luxurious.",
    footer: "From the street to the estate, one signature.",
    loading: "Loading",
    rights: "All rights reserved",
  },
};

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("anvocra_lang") || "tr");
  useEffect(() => {
    localStorage.setItem("anvocra_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = useCallback((k) => DICT[lang][k] ?? k, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);

export const pick = (p, field, lang) => p?.[`${field}_${lang}`] || p?.[`${field}_tr`] || "";

export const formatPrice = (n) => `₺${Number(n || 0).toLocaleString("tr-TR")}`;
